<div class="kanban-card-container">
  <ng-content></ng-content>
</div>
